module.exports = __webpack_public_path__ + "assets/private_question_icon_eye.33bb6eed.svg";